/* istanbul ignore file - better tested visually */

import { faCloudExclamation, faSquareThisWayUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ErrorPage } from '@partful/features/instructions/ui/ErrorPage';
import { LoadingPage } from '@partful/features/instructions/ui/LoadingPage';
import { ModelViewer } from '@partful/features/instructions/ui/ModelViewer/ModelViewer';
import { Button } from '@partful/shared/ui/Button';
import { useTenant } from '@providers/Tenant';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useModel } from '../../lib/useModel';
import styles from './Scene.module.scss';

export function Scene() {
  const { t: i18n } = useTranslation();
  const { accountId: account } = useTenant();
  const { configurationId: product } = useParams<{ configurationId: string }>();
  const [{ data: model, fetching, error }] = useModel({ account, product });

  const [changeCoordinateSystem, setChangeCoordinateSystem] = useState<boolean>(false);

  if (error) {
    return (
      <ErrorPage
        icon={<FontAwesomeIcon icon={faCloudExclamation} />}
        title={i18n('instructions:viewer.failedToLoadModelError.title')}
        message={i18n('instructions:viewer.failedToLoadModelError.message')}
        actions={
          <Button linkComponent={Link} to="/instructions">
            {i18n('instructions:viewer.failedToLoadModelError.backToLibrary')}
          </Button>
        }
      />
    );
  }

  if (!model || fetching) {
    return <LoadingPage />;
  }

  return (
    <div className={styles.viewer}>
      <div className={styles.canvas}>
        <ModelViewer model={model} swapYZAxis={changeCoordinateSystem} />
      </div>
      <Button
        onClick={() => setChangeCoordinateSystem((current) => !current)}
        size="small"
        variant={changeCoordinateSystem ? 'primary' : 'secondary'}
        className={styles.coordinateSystemButton}
      >
        <FontAwesomeIcon icon={faSquareThisWayUp} />
        {i18n('instructions:viewer.changeCoordinateSystem')}
      </Button>
    </div>
  );
}
